export { default } from './CicFeeChangesTable';
